import React from "react";
import { DropdownOption, useDropdown } from "../Pages/private/hooks/useDropdown";
import "../styles/Dropdown.scss"

interface CustomDropdownProps {
  options: DropdownOption[];
  selected: string;
  onSelect: (value: string) => void;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({ options, selected, onSelect }) => {
  const { isOpen, toggleDropdown, dropdownRef, selectOption } = useDropdown(selected, options);

  const handleSelect = (value: string) => {
    selectOption(value);
    onSelect(value);
  };

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <button onClick={toggleDropdown} className="dropdown-toggle">
        {selected}
        <span className="dropdown-arrow">{isOpen ? "▲" : "▼"}</span>
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {options.map(({ label, value }) => (
            <li
              key={value}
              onClick={() => handleSelect(value)}
              className={`dropdown-item ${value === selected ? "selected" : ""}`}
            >
              {label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;


// import React from "react";
// import { DropdownOption, useDropdown } from "Pages/private/hooks/useDropdown";

// interface CustomDropdownProps {
//   options: DropdownOption[];
//   selected: string;
//   onSelect: (value: string) => void;
// }

// const CustomDropdown: React.FC<CustomDropdownProps> = ({ options, selected, onSelect }) => {
//   const { isOpen, toggleDropdown, dropdownRef, selectOption } = useDropdown(selected, options);

//   const handleSelect = (value: string) => {
//     selectOption(value);
//     onSelect(value);
//   };

//   return (
//     <div className="custom-dropdown" ref={dropdownRef}>
//       <button onClick={toggleDropdown} className="dropdown-toggle">
//         {selected}
//         <span style={{ float: "right" }}>{isOpen ? "▲" : "▼"}</span>
//       </button>
//       {isOpen && (
//         <ul
//           className="dropdown-menu"
//           style={{
//             listStyle: "none",
//             margin: 0,
//             padding: 0,
//             position: "absolute",
//             width: "100%",
//             maxHeight: "150px",
//             overflowY: "auto",
//             border: "1px solid #ccc",
//             background: "#fff",
//             zIndex: 1000,
//           }}
//         >
//           {options.map(({ label, value }) => (
//             <li
//               key={value}
//               onClick={() => handleSelect(value)}
//               style={{
//                 padding: "8px 12px",
//                 cursor: "pointer",
//                 backgroundColor: value === selected ? "#eee" : "transparent",
//               }}
//             >
//               {label}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default CustomDropdown;
